import React from 'react';

import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';
import { CARD_THEMES } from './card_theme';
import { IndexCard, getIndexCards } from './index_card';
import { LinkCard, getCardPaths } from './link_card';

import type { DealToolCall } from '../types';
import type { LinkCardRecord } from './link_card';

interface DealCard extends LinkCardRecord {
  displayName: string | null;
  status: string;
}

interface DealCardsProps {
  toolCalls: DealToolCall[];
}

export function DealCards({ toolCalls }: DealCardsProps) {
  return (
    <>
      {getCardPaths(toolCalls).map(path => (
        <LinkCard key={path} path={path} theme={CARD_THEMES.deal}>
          {(deal: DealCard) => (
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold text-truncate">{deal.displayName}</span>
              <Badge appearance="muted" className="flex-shrink-0" variant="secondary">{deal.status}</Badge>
            </div>
          )}
        </LinkCard>
      ))}
      {getIndexCards(toolCalls).map(index => (
        <IndexCard index={index} key={index.path} label="deals" pageName="All Deals" theme={CARD_THEMES.deal} />
      ))}
    </>
  );
}
